module.exports = __webpack_public_path__ + "img/404.71ae7561.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/404.png
// module id = NeAH
// module chunks = 1